import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputMask from "react-input-mask";
import api from "../../../services/axios";
import { useTranslation } from "react-i18next";
import WalletSelect from "./WalletSelect";
const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
}));
export default function AlertDialog(props) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [name, setName] = React.useState("");
  const [number, setNumber] = React.useState("");
  const [inputs, setInputs] = React.useState([]);
  const [wallet, setWallet] = React.useState("");
  const [selectwallet, setSelectwallet] = React.useState(false);
  const classes = useStyles();
  const handleClose = () => {
    setOpen(false);
    props.func(false);
    setNumber("");
    setName("");
    setInputs([]);
  };
  React.useEffect(() => {
    setOpen(props.open);
  }, [props.open]);
  React.useEffect(() => {
    setName(props.data?.name);
    setNumber(props.data?.number);
    setWallet(props.data?.wallet);
  }, [props.data]);
  const moreInputs = () => {
    setInputs([
      ...inputs,
      <>
        <InputMask mask="99.999.999/9999-99">
          {() => (
            <TextField
              id={`outlined-basic cnpjindex${inputs.length}`}
              label="CNPJ"
              variant="outlined"
              required
            />
          )}
        </InputMask>
        <TextField
          id={`outlined-basic codindex${inputs.length}`}
          label={t("RET.editrepresentative.phcodclient")}
          variant="outlined"
          required
        />
        <TextField
          id={`outlined-basic rzsocialindex${inputs.length}`}
          label={t("RET.editrepresentative.phrz")}
          variant="outlined"
          required
        />
      </>,
    ]);
  };

  const confirm = async () => {
    if (!name.length || !number.length) {
      return window.alert(t("RET.editrepresentative.alert1"));
    }
    if (number.replace(/([^\d])+/gim, "").length !== 12) {
      return window.alert("Numero com formato incorreto!");
    }
    const data = {
      representative: {
        name,
        number: number.replace(/([^\d])+/gim, ""),
        idclient: props.data.idclient,
        idwallet: wallet ? wallet.idwallets : undefined,
      },
      establishments: [],
    };
    for (let i = 0; i <= inputs.length - 1; i++) {
      if (
        !document.getElementById(`outlined-basic cnpjindex${i}`).value ||
        !document.getElementById(`outlined-basic codindex${i}`).value ||
        !document.getElementById(`outlined-basic rzsocialindex${i}`).value
      ) {
        return window.alert(t("RET.editrepresentative.alert1"));
      }

      data.establishments.push({
        cnpj: document.getElementById(`outlined-basic cnpjindex${i}`).value,
        cod: document.getElementById(`outlined-basic codindex${i}`).value,
        rzsocial: document.getElementById(`outlined-basic rzsocialindex${i}`)
          .value,
      });
    }
    api
      .put("representatives", data, {
        headers: {
          Authorization: `Bearer ${localStorage.token}`,
        },
      })
      .then(async (res) => {
        await props.update();
        handleClose();
      })
      .catch((err) => window.alert(err.response.data.error));
  };
  return (
    <div>
      {selectwallet && (
        <WalletSelect
          close={() => {
            setSelectwallet(false);
          }}
          setWallet={setWallet}
          wallet={wallet}
        />
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("RET.editrepresentative.title")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("RET.editrepresentative.description")}
            <form className={classes.root} noValidate autoComplete="off">
              <TextField
                id="outlined-basic"
                label={t("RET.editrepresentative.phname")}
                variant="outlined"
                value={name}
                onChange={(e) => {
                  setName(e.currentTarget.value);
                }}
              />
              <TextField
                id="outlined-basic"
                label={t("RET.editrepresentative.phnumber")}
                variant="outlined"
                value={number}
                onChange={(e) => {
                  setNumber(e.currentTarget.value);
                }}
              />
              <br />
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setSelectwallet(true);
                }}
              >
                {t("CT.newclient.bt3")}
              </Button>
              {wallet && wallet.name}
              <h3>CNPJ :</h3>
              {inputs.map((input) => input)}
              <AddCircleIcon
                style={{ height: "3ch", width: "35.5ch", margin: 0 }}
                onClick={moreInputs}
              />
            </form>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            <Button variant="contained" color="secondary">
              {t("RET.editrepresentative.bt2")}
            </Button>
          </Button>
          <Button color="primary" onClick={confirm} autoFocus>
            <Button variant="contained" color="primary">
              {t("RET.editrepresentative.bt1")}
            </Button>
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
